var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_10133",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 10133",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_10118",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 10118",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8602-3",
    "data-name": "\\u9577\\u65B9\\u5F62 8602-3",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8284",
    "data-name": "\\u30D1\\u30B9 8284",
    d: "M313.777,348.357l-1.91-1.273-1.7-1.132a.752.752,0,0,0-1.01.164l-1.051,1.351a.749.749,0,0,1-.955.2,16.775,16.775,0,0,1-6.048-6.048.748.748,0,0,1,.2-.955l1.35-1.051a.752.752,0,0,0,.164-1.009l-1.1-1.645-1.309-1.963a.751.751,0,0,0-1.012-.228l-1.509.9a1.84,1.84,0,0,0-.837,1.083c-.413,1.5-.5,4.822,4.822,10.14s8.635,5.234,10.14,4.822a1.84,1.84,0,0,0,1.083-.837l.9-1.509A.751.751,0,0,0,313.777,348.357Z",
    transform: "translate(-293.076 -331.653)",
    fill: "#676767"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon_call.7adec896e45bcb42e331d33ab6e28554.svg";
export { ForwardRef as ReactComponent };